<template>
  <form class="form-signin" novalidate>
    <h1 v-if="!editMode" class="h3 mb-3 font-weight-normal text-center">Spritpreise hinzufügen</h1>
    <div v-if="step == 1">
      <div class="form-group">
        <label class="pt-2" for="userPLZ">Postleitzahl</label>
        <input
          id="gasPricePlz"
          class="form-control"
          aria-describedby="userPLZ"
          placeholder="PLZ oder Ort"
          required
          type="search"
          v-bind:value="newFeed.place"
          @input="searchPlace($event.target.value)"
        />
        <div class="invalid-feedback">{{this.errorMessage}}</div>
      </div>
      <div v-if="step == 1 && !userSelected  && places.suggestions.length > 0" class="form-group">
        <div class="card">
          <div class="card-header">Ort auswählen</div>
          <ul class="list-group list-group-flush">
            <button
              v-for="item in places.suggestions"
              v-bind:key="item.locationId"
              v-html="item.label"
              type="button"
              @click="selectPlace(item.locationId)"
              class="list-group-item list-group-item-action"
            ></button>
          </ul>
        </div>
      </div>
      <div class="form-group">
        <label for="inputFeed">Umkreis</label>
        <select
          id="inputFeed"
          class="custom-select"
          aria-label="Umkreis"
          v-model="newFeed.radius"
          required
        >
          <optgroup class="text-muted bg-light" label="Umkreis">
            <option value="1">1 km</option>
            <option value="2">2 km</option>
            <option value="5">5 km</option>
            <option value="10">10 km</option>
            <option value="25">25 km</option>
          </optgroup>
        </select>
      </div>
      <div class="form-group">
        <label for="inputGastype">Kraftstoff</label>
        <select
          id="inputGastype"
          class="custom-select"
          aria-label="Kraftstoff"
          v-model="newFeed.gastype"
          required
        >
          <optgroup class="text-muted bg-light" label="Kraftstoff">
            <option value="e5">Super</option>
            <option value="e10">E10</option>
            <option value="diesel">Diesel</option>
          </optgroup>
        </select>
      </div>
      <div class="container">
        <div class="row">
          <button
            type="submit"
            v-on:click.prevent="searchGasPrice()"
            class="btn btn-primary col-md order-md-last m-2"
          >
            <div v-show="!isLoading">Weiter <i class="fas fa-gas-pump" />
            </div>
            <div v-show="isLoading">
              <i class="fas fa-gas-pump fa-spin" />
            </div>
          </button>
        </div>
        <div class="row">
          <button
            type="button"
            v-on:click="onExecuteCancel"
            class="btn btn-primary col-md order-md-first m-2"
          >Abbrechen</button>
        </div>
      </div>
    </div>
    <user-menu-add-form
      v-if="step==2"
      :okButtonName="this.okButtonName"
      :initFeed="this.newFeed"
      :initStep="3"
      :callbackExecuteAction="this.onStartAction"
      v-on:executeCancel="onExecuteCancel"
    />
  </form>
</template>

<script>
import { mapActions } from "vuex";
import axios from "axios";

//import { Plugins } from "@capacitor/core";
//const { TuerPlugin } = Plugins;

//import "tuer-plugin";

import UserMenuAddForm from "../User.Menu.AddForm.vue";

export default {
  name: "ProviderGasPrice",
  components: {
    UserMenuAddForm
  },
  data: function() {
    return {
      errorMessage: "Geben Sie eine PLZ an",
      userSelected: false,
      isLoading: false,
      editMode: false,
      step: 1,
      places: { suggestions: [] },
      newFeed: {
        type: 3,
        url: "https://www.tankerkoenig.de",
        name: "Tanken",
        category: "",
        place: "",
        radius: 2,
        gastype: "e5",
        Position: {
          Latitude: 0,
          Longitude: 0
        }
      }
    };
  },
  props: {
    initFeed: Object
  },
  computed: {
    okButtonName() {
      if (this.editMode) return "Ändern";
      else return "Hinzufügen";
    }
  },
  mounted() {
    if (this.initFeed) {
      this.editMode = true;
      this.newFeed = this.initFeed;
    }
  },
  methods: {
    ...mapActions(["addUserFeed", "editUserFeed"]),
    onStartAction: function(feed) {
      if (this.editMode) {
        this.editUserFeed(feed).then(() =>
          this.$router.push({
            name: "user",
            params: { category: feed.categoryId }
          })
        );
      } else {
        this.addUserFeed(feed).then(() =>
          this.$router.push({
            name: "user",
            params: { category: feed.categoryId }
          })
        );
      }
    },
    onExecuteCancel: function() {
      this.$emit("executeStop");
    },
    selectPlace: function(locationId) {
      //let app_id = "sDrT9UXhlpCVbaw2pbut";
      //let app_code = "qkMjOnwOs6u-O0rt2FP4Pg";

      let gasUrl =
        "https://geocoder.api.here.com/6.2/geocode.json?locationId=" +
        locationId +
        "&app_id=sDrT9UXhlpCVbaw2pbut&app_code=qkMjOnwOs6u-O0rt2FP4Pg";
      this.userSelected = true;

      //TuerPlugin.echo({ value: gasUrl })
      axios.get(gasUrl).then(response => {
        if (response == "") {
          this.errorMessage = "Kein Ort gefunden";
        } else {
          this.newFeed.Position =
            response.data.Response.View[0].Result[0].Location.DisplayPosition;
          this.newFeed.place =
            response.data.Response.View[0].Result[0].Location.Address.Label;
          this.errorMessage = "";
        }
        let gasPriceElement = document.getElementById("gasPricePlz");
        gasPriceElement.setCustomValidity(this.errorMessage);
      });
    },
    searchPlace: function(aPlace) {
      let app_id = "sDrT9UXhlpCVbaw2pbut";
      let app_code = "qkMjOnwOs6u-O0rt2FP4Pg";

      this.newFeed.place = aPlace;
      this.userSelected = false;
      this.newFeed.Position.Latitude = 0;
      this.newFeed.Position.Longitude = 0;

      let requestURL =
        "https://autocomplete.geocoder.api.here.com/6.2/suggest.json" +
        "?app_id=" +
        app_id +
        "&app_code=" +
        app_code +
        "&query=" +
        encodeURIComponent(aPlace) +
        "&country=DEU" +
        "&language=de" +
        "&beginHighlight=<b>" +
        "&endHighlight=</b>";

      axios
        .get(requestURL, {
          responseType: "json"
        })
        .then(response => {
          if (response == "") {
            this.hasError = true;
          } else {
            this.places = response.data;
          }
        })
        .catch(error => {
          console.log(error);
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    searchGasPrice: function() {
      let gasPriceElement = document.getElementById("gasPricePlz");
      gasPriceElement.setCustomValidity("");

      if (this.newFeed.Position.Latitude == 0) {
        this.errorMessage = "Kein passenden Ort gefunden";
        gasPriceElement.setCustomValidity(this.errorMessage);
      }

      if (this.$el.checkValidity()) {
        this.isLoading = true;

        let gasUrl =
          "https://creativecommons.tankerkoenig.de/json/list.php?lat=" +
          this.newFeed.Position.Latitude +
          "&lng=" +
          this.newFeed.Position.Longitude +
          "8&rad=" +
          this.newFeed.radius +
          "&sort=dist&type=all&apikey=331bc57f-478e-bbbb-d6f2-1b3d3bfc4646";
        // "https://www.tankerkoenig.de/ajax_v3_public/get_stations_near_postcode.php?postcode=" +
        // this.newFeed.plz +
        // "&radius=" +
        // this.newFeed.radius +
        // "&gasType=" +
        // this.newFeed.gastype +
        // "&sort=price";

        //TuerPlugin.echo({ mode: "echo", value: gasUrl })
        axios
          .get(gasUrl)
          .then(response => {
            if (response == "") {
              this.errorMessage = "Keine Preise gefunden";
            } else {
              if (!response.data.ok) this.errorMessage = response.data.message;
              else {
                this.newFeed.url = gasUrl;
                this.step = 2;
              }
            }
          })
          .catch(error => {
            this.errorMessage = error;
          })
          .finally(() => {
            this.isLoading = false;

            gasPriceElement.setCustomValidity(this.errorMessage);

            // STart debug
            //gasPriceElement.setCustomValidity("");
            //this.newFeed.url = gasUrl;
            //this.step = 2;
            //end debug
            if (this.$el.checkValidity()) this.step = 2;
          });
      }
      this.$el.classList.add("was-validated");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
